export default "__VITE_ASSET__CKYbONTb__"